import { getAppStyleTokens, usesAppStyleGrammar } from './msiStyleTokens';

/**
 * MUI sx helpers for translucent surfaces/shadows — mode-conditional values
 * that can't be expressed as static Tailwind classes.
 */

// Translucent panel background for compact sub-panels (upload/ingest drop
// zones, execution data source card). Override the alpha for panels that
// need a different translucency tier.
export function frostedPanelBg(theme, { darkAlpha = 0.28, lightAlpha = 0.48 } = {}) {
  if (usesAppStyleGrammar(theme)) {
    return getAppStyleTokens(theme).palette.surface;
  }
  return theme.palette.mode === 'dark'
    ? `rgba(15, 23, 42, ${darkAlpha})`
    : `rgba(255, 255, 255, ${lightAlpha})`;
}

// Elevation shadow shared by the compact-controls popovers (FileUploader,
// PortfolioIngestPanel rail popover).
export const popoverElevationShadow = (theme) => (usesAppStyleGrammar(theme)
  ? (theme.palette.mode === 'dark'
    ? '0 8px 24px rgba(0, 0, 0, 0.28)'
    : '0 8px 24px rgba(12, 23, 38, 0.12)')
  : '0 8px 24px rgba(12, 23, 38, 0.12)');
